import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { hospiFeatureKey, hospitalizationReducer } from './state/hospi.reducer';
import { HospiEffects } from './state/hospi.effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(hospiFeatureKey, hospitalizationReducer),
    EffectsModule.forFeature([HospiEffects])
  ]
})
export class HospiModule { }
